module.exports = __webpack_public_path__ + "static/img/passion-08.e402500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-08.png
// module id = 133
// module chunks = 0